class FilterForm {
  constructor(form) {
    this.form = form;
    this.action = form.getAttribute('action');
    this.key = form.dataset.profileFilterForm;
    this.filterableContent = document.querySelector(`[data-filterable-content="${this.key}"]`);

    this.requestOrder = 0;
    this.bind();
  }

  bind() {
    this.bindInputs();
    this.bindPagination();
  }

  bindPagination() {
    const instance = this;
    const paginationLink = this.filterableContent.querySelector('[data-filter-pagination] .next a');

    if (paginationLink) {
      paginationLink.addEventListener('click', (e) => {
        e.preventDefault();
        const link = e.target;
        link.classList.add('_disabled');

        const jax = new Jax(
          paginationLink.getAttribute('href'),
          'GET',
          false
        );

        jax.send().then((html) => {
          const page = document.createElement('div');
          page.innerHTML = html;

          const currentList = this.filterableContent.querySelector('[data-replaceble]');
          const newList = page.querySelector(`[data-filterable-content="${instance.key}"] [data-replaceble]`);

          const currentPagination = this.filterableContent.querySelector('[data-filter-pagination]');
          const newPagination = page.querySelector('[data-filter-pagination]');

          if (newPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
            instance.bindPagination();
          } else {
            currentPagination.remove();
          }

          Array.from(newList.children).forEach((child) => {
            currentList.appendChild(child);
          });

          document.dispatchEvent(new Event('DOMContentMutated'));
        });
      });
    }
  }

  bindInputs() {
    const instance = this;
    const selects = this.form.querySelectorAll('select');

    selects.forEach((select) => {
      select.addEventListener('change', (e) => {
        instance.handleChain(select);

        instance.debounceRequest();
      });
    });
  }

  handleChain(select) {
    const instance = this;
    const wrap = select.closest('[data-chain-field]');
    const chainKey = wrap ? wrap.dataset.chainField : null;

    if (!chainKey) {
      return
    }

    const value = select.value;
    const dependWraps = instance.form.querySelectorAll(`[data-chain-field][data-depend="${chainKey}"]`);
    dependWraps.forEach((dependWrap) => {
      const groups = dependWrap.querySelectorAll('optgroup');
      groups.forEach((group) => {
        const groupKey = group.dataset[chainKey];
        if (value === 'all' || value === groupKey) {
          group.disabled = '';
        } else {
          group.disabled = 'disabled';
        }
      });
    });
  }


  debounceRequest() {
    const instance = this;
    this.requestOrder++;

    setTimeout(() => {
      instance.requestOrder--;
      if (instance.requestOrder <= 0) {
        instance.requestOrder = 0;
        instance.request();
      }
    }, 400);
  }

  request() {
    const instance = this;
    const jax = new Jax(
      this.form.getAttribute('action'),
      this.form.getAttribute('method'),
      false
    );
    jax.send(new FormData(this.form)).then((html) => {
      instance.replaceContent(html);
    });
  }

  replaceContent(html) {
    const page = document.createElement('div');
    page.innerHTML = html;

    const newProductList = page.querySelector(`[data-filterable-content="${this.key}"]`);
    const currentProductList = this.filterableContent;

    if (newProductList && currentProductList) {
      currentProductList.innerHTML = newProductList.innerHTML;
    }

    this.bindPagination();
    document.dispatchEvent(new Event('DOMContentMutated'));
  }
}

function initFilters() {
  const filters = document.querySelectorAll('[data-profile-filter-form]');
  filters.forEach((form) => {
    new FilterForm(form);
  })
}
document.addEventListener('DOMContentLoaded', initFilters);

